const errorMsgs = {
  default: 'opening_times.validation.default',
  comparison: 'opening_times.validation.comparison',
  weekIsClosed: 'opening_times.validation.closedWeek',
};

export default class OpeningTimesValidator {
  static validate(openingTimes) {
    const days = Object.keys(openingTimes);

    return isWeekClosed(days, openingTimes)
      ? { week: errorMsgs.weekIsClosed }
      : validateDays(days, openingTimes);
  }
}

const validateDays = (days, openingTimes) =>
  days.reduce((daysErrors, day) => {
    if (!openingTimes[day].isOpen) {
      return { ...daysErrors };
    }

    const errors = validateDay(openingTimes[day]);

    return {
      ...daysErrors,
      ...(hasErrors(errors) ? { [day]: { ...errors } } : undefined),
    };
  }, {});

const hasErrors = errors => Object.keys(errors).length !== 0;

const isWeekClosed = (days, openingTimes) => {
  const isDayOpen = day => openingTimes[day].isOpen;
  return days.filter(isDayOpen).length === 0;
};

const validateDay = day => {
  const errors = {};

  if (!day.isOpen) return errors;

  if (!isTimeValid(day.open)) {
    errors.open = errorMsgs.default;
  }

  if (!isTimeValid(day.close)) {
    errors.close = errorMsgs.default;
  }

  if (isTimeComparisonValid(day.open, day.close) && !hasErrors(errors)) {
    errors.open = errorMsgs.comparison;
  }

  return errors;
};

const isTimeValid = time => {
  if (!time) return false;

  if (time.length === 8) {
    const normalizedTime = normalizeTime(time);
    return isTimeValid(normalizedTime);
  }

  const hasUnderline = time.indexOf('_') !== -1;

  if (hasUnderline) return false;

  const [strHours, strMinutes] = time.split(':');

  const hours = parseInt(strHours, 10);
  const minutes = parseInt(strMinutes, 10);

  const isValidHours = hours >= 0 && hours < 24;
  const isValidMinutes = minutes >= 0 && minutes < 60;

  return isValidHours && isValidMinutes;
};

const isTimeComparisonValid = (open, close) => timeToInteger(open) >= timeToInteger(close);

const timeToInteger = time => {
  if (typeof time !== 'string') return undefined;
  const normalized = normalizeTime(time);
  return parseInt(normalized.replace(/[:]/g, '').replace(/[_]/g, ''), 10);
};

const normalizeTime = time => {
  const [strHours, strMinutes] = time.split(':');
  return `${strHours}:${strMinutes}`;
};



// WEBPACK FOOTER //
// ../ui-components/components/DealerOpeningTimes/OpeningTimesValidator.js